import styled from 'styled-components';

import { STYLE, COLOR, mobile, big, ie } from '../../../styles/variables';
import { Caption, Navbar } from '../../../config/models';
import ReadingProgress from '../../../utils/modules/reading-progress';

export const LogoWrapper = styled.a`
    width: 0;
    z-index: 1;

    svg {
        display: block;
    }
`;

export const StyledNavbar = styled.nav<{ height: string; isExpanded?: boolean; caption?: Caption }>`
    display: flex;
    position: fixed;
    top: 0;
    z-index: 9999;
    width: 100%;
    max-width: ${STYLE.page.maxWidth};
    color: white;
    background-color: ${COLOR.br24.darkGrey};

    ${LogoWrapper} {
        svg {
            height: ${({ height, isExpanded, caption }) =>
                `calc(${height} - ${isExpanded && caption ? '0px' : '10px'})`};
            transition: height 0.25s ease-in-out;

            @media ${mobile} {
                height: ${STYLE.navbar.sizes[Navbar.SMALL].height};
            }

            @media ${ie} {
                transition: width 0.25s ease-in-out;
                width: ${({ height, isExpanded, caption }) =>
                    `calc(${height} - ${isExpanded && caption ? '0px' : '10px'})`};
            }
        }
    }
`;

export const NavbarWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const NavbarInner = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-grow: 1;
    width: 100%;
    padding-left: 120px;

    @media ${mobile} {
        padding-left: 80px;
        justify-content: flex-start;
    }

    @media ${ie} {
        justify-content: flex-start;
    }
`;

export const NavbarTitle = styled.div<{ showTitle: boolean }>`
    margin-left: auto;
    font-size: 1rem;
    transition: opacity 0.5s ease;
    opacity: ${({ showTitle }) => (showTitle ? 1 : 0)};

    @media ${mobile} {
        text-align: center;
        font-size: 1.2rem;
        display: none;
    }
`;

export const CaptionWrapper = styled.div<{ caption?: Caption; isExpanded?: boolean }>`
    display: ${({ caption }) => (caption ? 'flex' : 'none')};
    align-items: center;
    font-weight: 700;
    font-size: 0.95rem;
    text-transform: uppercase;
    padding-left: 120px;
    overflow: hidden;
    background-color: ${({ caption }) => (caption ? COLOR.captions[caption] : COLOR.br24.darkGrey)};
    height: ${({ isExpanded, caption }) => (isExpanded && caption ? '20px' : '0px')};
    opacity: ${({ isExpanded, caption }) => (isExpanded && caption ? 1 : 0)};
    transition: height 0.25s ease-in-out, opacity 0.25s ease-in-out;

    @media ${big} {
        height: ${({ isExpanded, caption }) => (isExpanded && caption ? '25px' : '0px')};
    }

    @media ${mobile} {
        padding-left: 80px;
        display: none;
    }
`;

export const MainCaption = styled.div`
    display: none;
    text-transform: uppercase;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 0.9rem;

    @media ${mobile} {
        display: block;
    }
`;

export const DotCaptionSpan = styled.span`
    display: flex;
    align-items: center;
    font-weight: 700;
    z-index: 999;
`;

export const Dot = styled.div<{ caption: Caption }>`
    display: inline-block;
    height: 7px;
    width: 7px;
    background-color: ${({ caption }) => COLOR.captions[caption]};
    border-radius: 50%;
    margin-right: 10px;

    @media ${mobile} {
        height: 12px;
        width: 12px;
    }
`;

const defaultReadingProgressColor = (caption?: Caption) =>
    (caption && COLOR.captions[caption as Caption]) || COLOR.primary;

export const ReadProgress = styled(ReadingProgress)<{ height: string; isExtended?: boolean; caption: Caption }>`
    color: ${defaultReadingProgressColor()};
    background-color: transparent;
    width: 100%;
    height: ${({ isExtended, caption }) => (caption && isExtended ? '0px' : '4px')};
    transition: height 0.25s ease-in-out;

    @media ${mobile} {
        height: 4px;
    }

    @media ${big} {
        height: ${({ isExtended, caption }) => (caption && isExtended ? '0px' : '5px')};
    }

    &::-webkit-progress-bar {
        background: transparent;
    }
    &::-webkit-progress-value {
        background: ${defaultReadingProgressColor()};
    }
    &::-moz-progress-bar {
        background-color: ${defaultReadingProgressColor()};
    }
    &::-webkit-progress-value {
        background: ${defaultReadingProgressColor()};
    }
    &::-moz-progress-bar {
        background-color: ${defaultReadingProgressColor()};
    }
`;
